import React from 'react';
import PropTypes from 'prop-types';

const Accounting = ({ altText }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' fill='none'>
      <title id='accounting-title'>{altText}</title>
      <path fill='currentColor' d='M5 4.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V5A.75.75 0 0 1 5 4.25ZM9.75 9a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0V9Z' />
      <path fill='currentColor' fillRule='evenodd' d='M4 .25A3.75 3.75 0 0 0 .25 4v10A3.75 3.75 0 0 0 4 17.75h7.264a2.25 2.25 0 0 0 2.236 2h4a2.25 2.25 0 0 0 2.25-2.25v-1c0-.576-.217-1.102-.573-1.5.356-.398.573-.924.573-1.5v-1c0-.576-.217-1.102-.573-1.5.356-.398.573-.924.573-1.5v-1a2.25 2.25 0 0 0-2.25-2.25h-.75V4A3.75 3.75 0 0 0 13 .25H4Zm11.25 6V4A2.25 2.25 0 0 0 13 1.75H4A2.25 2.25 0 0 0 1.75 4v10A2.25 2.25 0 0 0 4 16.25h7.264c.053-.478.255-.91.559-1.25a2.242 2.242 0 0 1-.573-1.5v-1c0-.576.217-1.102.573-1.5a2.242 2.242 0 0 1-.573-1.5v-1a2.25 2.25 0 0 1 2.25-2.25h1.75Zm2.25 5.5h-4a.75.75 0 0 0-.75.75v1c0 .414.336.75.75.75h4a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75Zm0-1.5a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75h-4a.75.75 0 0 0-.75.75v1c0 .414.336.75.75.75h4Zm-4 5.5h4a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 .75-.75Z' clipRule='evenodd' />
    </svg>
  );
};

Accounting.propTypes = {
  altText: PropTypes.string
};

export default Accounting;
